import Vue from 'vue';
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';

// TODO Low: Drop this file, test if Vue is loaded via webpack async loading (without the use of `import`)?
// Init due to DSN present?
let dsn = document?.documentElement?.getAttribute('data-sentry-dsn');

if (dsn) {

    Sentry.init({
        dsn,
        integrations: [
            new Integrations.Vue({
                Vue,
                attachProps: true
            }),
        ]
    });
}
